import { render, staticRenderFns } from "./itemDate.vue?vue&type=template&id=c467e12a&scoped=true&"
import script from "./itemDate.vue?vue&type=script&lang=js&"
export * from "./itemDate.vue?vue&type=script&lang=js&"
import style0 from "./itemDate.vue?vue&type=style&index=0&id=c467e12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c467e12a",
  null
  
)

export default component.exports